import $ from 'jquery'

var intmeg = setInterval(function () {
	if ($('.Megamenu').hasClass('is-ready')) {
		menufn();
		clearInterval(intmeg);
	}
}, 500);

function menufn() {

	$('ul.Megamenu > li.Megamenu-item > a[aria-expanded]')
		.on('click', function (e) {
			e.preventDefault();
		})
		.dblclick(function (e) {
			document.location = $(this).attr('href');
		});

	$('ul.Megamenu [data-icon]').each(function () {
		$(this).addClass('fa fa-fw fa-' + $(this).data('icon'));
	});

	if ($(window).height() < 1024) {
		$('.Megamenu-subnav').each(function () {
			if ($(this).find('.Megamenu-subnavGroup').length > 3) {
				$(this).addClass('big');
			}
		});
	}
}

$('.Linklist-link.is-collapsed').click(function (e) {
	e.preventDefault();
	$(this).off('click').find('+ul').hide().removeClass('u-hidden').slideDown();
});

// Sottomenu in menu se presente
function navscroll() {
	var $nav = $('aside .sticky .navscroll');
	if ($nav.length === 0) return;
	var text    = $nav.prev(':header').text();
	var $active = $("aside").find('.active,.current-menu-item').find(">a:contains('" + text + "')");
	if ($active.length === 0) return;
	$nav.parents('.sticky').remove();
	$nav.insertAfter($active).attr('class', 'u-text-xxs');

	$nav.navScroll({
		mobileDropdown   : true,
		mobileBreakpoint : 768,
		scrollSpy        : true,
		navHeight        : 75,
		activeClassName  : $(this).data('class'),
		onScrollStart    : function () {
			history.pushState({}, $(this).text(), $(this).attr('href'));
		}
	});

	$active.parents('ul.Linklist').data('class', 'u-background-5').parentsUntil('aside').last().addClass('sticky');
}

navscroll();




// WEBPACK FOOTER //
// ./src/themes/pac/js/menu.js